// Presentation-only helpers. No API calls, credentials, state writes or routing side effects.
export const workspaceKinds = ['sales', 'accounts', 'training'];
const paths = { '/sales-ops': 'sales', '/whatsapp-manager': 'accounts', '/ai-training': 'training' };
export function appKind(app, origin) {
  const frame = app?.content?.find(item => item.type === 'frame');
  if (!frame?.url) return null;
  try {
    const url = new URL(frame.url, origin);
    if (url.origin !== origin) return null;
    return paths[url.pathname.replace(/\/$/, '')] || null;
  } catch { return null; }
}
export function workspaceRequestMatches(request, chat, accountId, apps, origin) {
  return Boolean(request && chat?.id && String(request.accountId) === String(accountId)
    && String(chat.account_id) === String(accountId)
    && String(request.conversationId) === String(chat.id)
    && (request.kind === 'conversations' && request.appId === undefined
      || apps.some(app => String(app.id) === String(request.appId) && appKind(app, origin))));
}
export const labelKeys = {
  'ai-draft-ready': 'DRAFT', 'ai-needs-human': 'HUMAN',
  'ai-opt-out': 'OPT_OUT', 'ai-auto-replied': 'REPLIED',
};
export const secondaryNames = ['Inbox', 'Captain', 'Calls', 'Companies', 'Reports', 'Campaigns', 'Portals'];
